###
# Запись в сводной таблице биллинговых операций организации.
###
App.BillingOperation = DS.Model.extend
  sum           : DS.attr 'number'
  type          : DS.attr 'string'
  name          : DS.attr 'string'
  actual_date   : DS.attr 'date'

  organization:  DS.belongsTo 'organization', async: true
  invoice:       DS.belongsTo 'invoice',      async: true

  isPayment: Em.computed.equal('type', 'payment')
  isInvoice: Em.computed.equal('type', 'invoice')
